import { PropertySnapshot } from '../PropertySnapshot';

export default function isPropertySnapshot(
  maybePropertySnapshot: any,
): maybePropertySnapshot is PropertySnapshot {
  return maybePropertySnapshot instanceof PropertySnapshot;
}
